import { styled } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  &:not(:last-child) {
    padding-bottom: 16px;
    border-bottom: 1px solid ${BRAND_COLORS.stroke};
  }
`;

export const Label = styled.p`
  ${TYPOGRAPHY.CIRCULAR.bold}

  font-size: 12px;
  line-height: 20px;

  color: ${BRAND_COLORS.black};

  text-transform: uppercase;
`;

export const Value = styled.div<{ $gap?: number; }>`
  display: flex;
  flex-direction: column;

  gap: ${({ $gap = 0 }) => $gap}px;
`;
